import type { SurfacedAsyncItem } from '../selectors/getSurfacedAsyncItems';
import type { AsyncTaskState } from 'owa-copilot-async-chat-types';

/**
 * The states ordered by urgency, most urgent first. Used to pick the single state that
 * represents a mixed backlog (e.g. the pane-selector badge color / most-urgent response type).
 */
const STATE_BY_URGENCY: readonly AsyncTaskState[] = [
    'failed',
    'needsAttention',
    'completed',
    'inProgress',
];

/**
 * Returns the most urgent state among the given items, or `undefined` when there are none.
 * Urgency follows {@link STATE_BY_URGENCY}: failed > needsAttention > completed > inProgress.
 */
export function getMostUrgentState(items: SurfacedAsyncItem[]): AsyncTaskState | undefined {
    let mostUrgent: AsyncTaskState | undefined;
    let mostUrgentRank = STATE_BY_URGENCY.length;

    for (const { state } of items) {
        const rank = STATE_BY_URGENCY.indexOf(state);
        if (rank !== -1 && rank < mostUrgentRank) {
            mostUrgent = state;
            mostUrgentRank = rank;
            // Ranked first: nothing can outrank it.
            if (rank === 0) {
                break;
            }
        }
    }

    return mostUrgent;
}
